export default [
  { name: "Hauptdeck", value: "Hauptdeck" },
  { name: "Oberdeck", value: "Oberdeck" },
  { name: "Sonnendeck", value: "Sonnendeck" }
];
